<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.mdAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.smAndDown}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/prize_shop">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-2" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Каталог призов") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-3" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ content.MAIN_PRODUCT.NAME }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <div class="detail">
                    <div class="detail__left">
                        <div class="detail__left-title">
                            {{ content.MAIN_PRODUCT.NAME }}
                        </div>
                        <div class="detail__left-desc">
                            {{ content.MAIN_PRODUCT.PREVIEW_TEXT }}
                        </div>
                        <hr>
                        <div class="detail__left-price">
                            {{ content.MAIN_PRODUCT.PRICE }} баллов
                        </div>
                        <div v-if="content.IS_GROUP">
                            <div class="detail__left-size">
                                Выберите размер
                            </div>
                            <div class="detail__left-size-container">
                                <div v-for="(item, id) in sizes" :key="id" class="detail__left-size-item"
                                     :class="{
                                         'active' : idx === item.id && item.REMAINDER !== 0,
                                         'disabled': item.REMAINDER === 0
                                     }"
                                     @click="item.REMAINDER === 0 ? '' : isActive(item.id) || idx === item.id ? '' : isActive(item.id)"
                                >{{ item.size }}</div>
                            </div>
                        </div>
                        <div v-if="point < 0 && content.MAIN_PRODUCT.REMAINDER !== 0" class="prize-catalog__error"> Не хватает {{ point * -1 }} баллов</div>
                        <div v-if="content.MAIN_PRODUCT.REMAINDER === 0" class="prize-catalog__error"> Товара нет в наличии </div>
                        <div v-if="MAX_COUNT_YEAR <= 0" class="prize-catalog__error"> Лимит по товару исчерпан </div>
                        <div @click="!disabled ? addItemToBasket(idx) : ''">
                            <buttonRed :disabled="disabled" style="width: 100%; height: 62px; margin: 40px 0" v-text="$t('В корзину')" />
                        </div>
                    </div>
                    <div class="detail__right">
                        <div class="detail__right-img">
                            <img class="detail__right-img-img" :src="activeImage ? activeImage : defaultImage">
                        </div>
                        <div class="detail__right-slider">
                            <Prize_shop_slider :changeImage="changeImage" :images="content.MAIN_PRODUCT.GALLERY" />
                        </div>
                    </div>
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonRed from '@/components/ui/buttons/button_red';
import Prize_shop_slider from '@/components/view_blocks/Prize_shop/Prize_shop_slider';
import {mapActions, mapGetters} from 'vuex';
export default {
  components: {
    Prize_shop_slider,
    HeaderMenu, UserMenu, FooterBlock, buttonRed,
  },
  data() {
    return {
      idx        : null,
      activeImage: '',
    };
  },
  beforeMount() {
    this.getDetail(this.$route.params.id);
  },
  mounted() {
    this.idx = this.$route.params.id;
  },
  computed: {
    ...mapGetters('order/CatalogDetail', ['content', 'sizes']),
    ...mapGetters('profile/user', [
      'user',
    ]),
    MAX_COUNT_YEAR() {
      return this.content.MAIN_PRODUCT.MAX_COUNT_YEAR - (this.content.MAIN_PRODUCT.IN_BASKET_NOW + this.content.MAIN_PRODUCT.BUY_EARLY_PRODUCT);
    },
    disabled() {
      if (this.point < 0 || this.MAX_COUNT_YEAR <= 0) {
        return true;
      } else {
        return false;
      }
    },
    defaultImage() {
      return this.content.MAIN_PRODUCT.GALLERY[0];
    },
    point() {
      if (this.content.MAIN_PRODUCT.REMAINDER === 0) {
        return -1;
      } else {
        return this.user.points - this.content.MAIN_PRODUCT.PRICE;
      }
    },
  },
  methods: {
    isActive(id) {
      this.idx = id;
      this.getDetail(id);
      this.$router.push({name: 'prize_detail', params: {id: id}});
    },
    addItemToBasket(id) {
      this.addBasket(id);
      this.getDetail(id);
    },
    ...mapActions('order/Basket', ['addBasket']),
    ...mapActions('order/Basket', ['getBasket']),
    ...mapActions('order/CatalogDetail', ['getDetail']),
    changeImage(image) {
      this.activeImage = image;
    },
  },
};
</script>

<style scoped lang="sass">

hr
    border: 1px solid #DEDEDE

.active
    background-color: #E4183E
    color: #FFFFFF

.disabled
    cursor: not-allowed !important
    border: 1px solid #DEDEDE
    color: #DEDEDE
    display: block
    position: relative
    overflow: hidden
    &:hover
        border: 1px solid #DEDEDE !important

    &:before
        content: ''
        position: absolute
        display: block
        width: auto
        height: auto
        left: 0
        top: 0
        right: 0
        bottom: 0
        background: url('/icons/disabled-item.svg') no-repeat
        background-size: 100% 100%


.detail
    display: flex
    justify-content: space-between
    margin-top: 115px
    @media screen and (max-width: 960px)
        margin-top: 50px
        flex-wrap: wrap

    &__right
        width: 50%
        @media screen and (max-width: 960px)
          width: 100%
          padding: 0 15px
        &-img
            display: flex
            justify-content: center
            width: 100%
            max-width: 621px
            height: 509px
            margin: 0 0 24px 0

        &-slider
            display: flex
            justify-content: center
            @media screen and (max-width: 670px)
                width: 90%

            &-arrow
                width: 52px
                height: 50.78px
                background-color: #F8F8F8
                z-index: 2
                margin-top: 29px
                cursor: pointer

                &.right
                    margin-left: -24px
                    display: flex
                    align-items: center
                    justify-content: center
                    transition: color 0.3s ease-in-out
                    font-size: 20px
                    font-weight: 500
                    &:hover
                      color: #E4183E

                    &:before
                        content: ">"


                &.left
                    margin-right: -24px
                    display: flex
                    align-items: center
                    justify-content: center
                    transition: color 0.3s ease-in-out
                    font-size: 20px
                    font-weight: 500

                    &:hover
                      color: #E4183E

                    &:before
                      content: "<"


    &__left
        width: 40%
        @media screen and (max-width: 960px)
            width: 100%
            padding: 0 15px
        &-title
            font-size: 42px
            font-weight: 400
            line-height: 140%
            color: #4A4A4A

        &-desc
            margin: 24px 0 40px 0
            font-size: 24px
            line-height: 29px
            font-weight: 400
            color: #838688

        &-price
            margin: 40px 0
            color: #E4183E
            font-size: 48px
            line-height: 58px
            font-weight: 400

        &-size
            font-size: 16px
            line-height: 17px
            color: #4A4A4A
            margin: 40px 0 24px 0
            font-weight: 400

            &-container
                display: flex
                flex-direction: row

            &-item
                width: 77px
                height: 38px
                display: flex
                justify-content: center
                align-items: center
                border: 1px solid #DEDEDE
                cursor: pointer
                margin: 0 6px
                transition: border 0.3s ease-in-out
                &:nth-child(1)
                    margin: 0 6px 0px 0px

                &:hover
                    border: 1px solid #FF718B

</style>
